"use strict";

import "./Pin.css";
import React from "react";
import classnames from "classnames";
import Checkbox from "./../Checkbox";
import pinall from "./pinall.svg";

export default class Pin extends React.Component {
	
	render() {
		return (
			<Checkbox
				checked={this.props.checked}
				indeterminate={this.props.indeterminate}
				onChange={this.props.onChange}
				className={classnames(this.props.className, "Pin")}
				icon={{
					on: this.props.useForAll ? {type: "svg", src: pinall} : "pin",
					off: "pin",
					indeterminate: "pin"
				}}
			/>
		);
	}
	
}

Pin.propTypes = {
	checked: React.PropTypes.bool,
	indeterminate: React.PropTypes.bool,
	onChange: React.PropTypes.func,
	useForAll: React.PropTypes.bool
};

Pin.defaultProps = {
	checked: false,
	indeterminate: false,
	onChange: value => {},
	useForAll: false
};


// WEBPACK FOOTER //
// ./~/vwa/components/Pin/Pin.jsx